module.exports = __webpack_public_path__ + "static/media/saber-slash.54b5f3f7.svg";